import { Form, FormProps, Input, Select } from "@pankod/refine-antd";
import { FeatureFlagTagInput } from "components/extra/feature-flag-tag-input";
import {
  FEATURE_FLAG_CONTEXT_OPTIONS,
  FEATURE_FLAG_KEY_PATTERN,
  FEATURE_FLAG_STATUS_OPTIONS,
  FEATURE_FLAG_TYPE_OPTIONS,
} from "pages/feature-flags/utils/feature-flags.helpers";

type FeatureFlagsFormProps = {
  formProps: FormProps;
};

export const FeatureFlagsForm: React.FC<FeatureFlagsFormProps> = ({
  formProps,
}) => {
  return (
    <Form
      {...formProps}
      layout="vertical"
      initialValues={{
        enabled: false,
        ...formProps.initialValues,
      }}
    >
      <Form.Item
        label="Nome"
        name="name"
        rules={[{ required: true, whitespace: true, message: "Informe o nome" }]}
      >
        <Input placeholder="Digite o nome" />
      </Form.Item>

      <Form.Item
        label="Key"
        name="key"
        rules={[
          { required: true, whitespace: true, message: "Informe a key" },
          {
            pattern: FEATURE_FLAG_KEY_PATTERN,
            message: "Use apenas letras minúsculas, números, hífen e underscore",
          },
        ]}
      >
        <Input placeholder="Key" />
      </Form.Item>

      <Form.Item
        label="Status"
        name="enabled"
        rules={[{ required: true, message: "Selecione o status" }]}
      >
        <Select
          options={FEATURE_FLAG_STATUS_OPTIONS}
          placeholder="Selecione o status"
        />
      </Form.Item>

      <Form.Item
        label="Tipo"
        name="flag_type"
        rules={[{ required: true, message: "Selecione o tipo" }]}
      >
        <Select
          options={FEATURE_FLAG_TYPE_OPTIONS}
          placeholder="Selecione o tipo"
        />
      </Form.Item>

      <Form.Item
        label="Contexto"
        name="contexts"
        rules={[{ required: true, message: "Selecione o contexto" }]}
      >
        <Select
          options={FEATURE_FLAG_CONTEXT_OPTIONS}
          placeholder="Selecione o contexto"
        />
      </Form.Item>

      <Form.Item label="Repositório (consumo)" name="target_repos">
        <FeatureFlagTagInput placeholder="Digite e separe por vírgula" />
      </Form.Item>

      <Form.Item label="Tags" name="tags">
        <FeatureFlagTagInput placeholder="Digite e separe por vírgula" />
      </Form.Item>
    </Form>
  );
};
